import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { EnvironmentService } from 'src/app/services/environment.service';
import { FacilityConfig, VideoWidgetConfig } from 'src/environments/environment.interface';

@Component({
  selector: 'app-video-widget',
  templateUrl: './video-widget.component.html',
  styleUrls: ['./video-widget.component.scss']
})
export class VideoWidgetComponent implements OnInit, AfterViewInit {
  settings: FacilityConfig;
  videoWidgetConfig: VideoWidgetConfig;
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
  
  constructor(
    _environmentService: EnvironmentService
  ) { 
    this.settings = _environmentService.getFacilityConfig();
    this.videoWidgetConfig = this.settings.homePage.videoWidget;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (this.videoPlayer) {
      // Ensure video is muted for autoplay
      this.videoPlayer.nativeElement.muted = true;
      this.videoPlayer.nativeElement.play().catch(error => {
        console.log('Autoplay failed:', error);
      });
    }
  }

}
